import { render } from "./LabCreate.vue?vue&type=template&id=387e15ad"
import script from "./LabCreate.vue?vue&type=script&lang=js"
export * from "./LabCreate.vue?vue&type=script&lang=js"

import "./LabCreate.vue?vue&type=style&index=0&id=387e15ad&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__